import { ApolloLink, Observable } from '@apollo/client';
import AuthService from 'services/Auth';
import { LOCALHOST_URL } from 'constants/regex';

type ExtraHeaders = Record<string, string | undefined>;

interface Props {
  projectName:
    | 'users-api'
    | 'properties-api'
    | 'importer-api'
    | 'geospatial-api'
    | 'data-science'
    | 'avant-functions';
  getExtraHeaders?: () => ExtraHeaders;
}

export const createOktaServiceTokenLink = (props: Props) => {
  const { projectName, getExtraHeaders } = props;

  return new ApolloLink((operation, forward) => {
    return new Observable(observer => {
      let sub: { unsubscribe: () => void } | undefined;

      (async () => {
        const extraHeaders = getExtraHeaders?.() ?? {};

        const url = window._env_.REACT_APP_GRAPHQL_API_URL;
        const isLocalGraphql = LOCALHOST_URL.test(url);

        if (isLocalGraphql) {
          operation.setContext(({ headers = {} }) => ({
            headers: {
              ...headers,
              ...extraHeaders,
            },
          }));

          sub = forward(operation).subscribe({
            next: v => observer.next(v),
            error: e => observer.error(e),
            complete: () => observer.complete(),
          });
          return;
        }

        await AuthService.setOktaToken();

        operation.setContext(({ headers = {} }) => ({
          headers: {
            ...headers,
            'x-api-token': AuthService.getOktaToken(projectName),
            'ay-api-auth': 'OKTA',
            ...extraHeaders,
          },
        }));

        sub = forward(operation).subscribe({
          next: v => observer.next(v),
          error: e => observer.error(e),
          complete: () => observer.complete(),
        });
      })().catch(e => observer.error(e));

      return () => sub?.unsubscribe();
    });
  });
};
